import {type FC, useEffect} from 'react';
import type {PlaylistInfo} from '../types';
import {Col, PlaylistSection, Row, Title} from '../types/Replay.styled.ts';
import ThumbnailCardItem from './ThumbnailCardItem.tsx';
import {FocusContext, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';

interface PlaylistProps {
    title: string;
    videoList: Array<PlaylistInfo>;
    sectionIndex: number;
}

const PlayList: FC<PlaylistProps> = ({title, videoList, sectionIndex}) => {
    const {ref, focusKey} = useFocusable({
        focusKey: `section-${sectionIndex}`,
        preferredChildFocusKey: `section-${sectionIndex}-item-0`,
        trackChildren: true,
        saveLastFocusedChild: true,
        onFocus: () => {
            if (ref.current) {
                ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
        },
        onArrowPress: (direction) => {
            if (direction === 'up' && sectionIndex === 0) {
                setFocus('go-download-page');
                return false;
            }
            return true;
        },
    });

    return (
        <FocusContext.Provider value={focusKey}>
            <PlaylistSection ref={ref}>
                <Title>{title}</Title>
                <Row>
                    {videoList.map((value, itemIndex) => (
                        <Col key={`col-${sectionIndex}-${itemIndex}`}>
                            <ThumbnailCardItem videoInfo={value} sectionIndex={sectionIndex} itemIndex={itemIndex} />
                        </Col>
                    ))}
                </Row>
            </PlaylistSection>
        </FocusContext.Provider>
    );
};

export default PlayList;
